import styled from 'styled-components'

export const DashboardCard = styled.div`
  height: 100%;
  width: 100%;
`
